import { Button, Paper, Typography, useTheme } from "@mui/material";

function ConsentExpired(): JSX.Element {
  const theme = useTheme();
  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        maxWidth: 600,
        width: '100%',
        borderRadius: '16px',
        textAlign: 'center',
        backgroundColor: 'background.default', 
      }}
    >
      <Typography variant="h5" fontWeight={600} sx={{ mt: 1, mb: 2, color: 'primary.main', }}>
        Consent for Adding Joint Holder
      </Typography>
      <Typography variant="body_500" sx={{ mt: 1, mb: 2, color: 'primary.light', fontWeight: 600 }}>
        Oops! Your application Link might have expired or been cancelled.
      </Typography>
      <Typography variant="body_500" color="text.secondary" sx={{ mt: 1, mb: 2, color: 'primary.main', fontWeight: 400 }}>
        Please contact your Relationship Manager (RM) for assistance.
      </Typography>

      {/* <Button
        variant="contained"
        color="primary" 
        sx={{ mt: 4, px: 4, py: 1 }} 
      >
        Contact RM
      </Button> */}
    </Paper>
  );
}

export default ConsentExpired;